// extracted by mini-css-extract-plugin
export var documentation = "_la-1";
export var menu = "_la-0";